import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React from 'react';

import styles from '@lmt/unicorn-shared/app/components/calendar/PatientAndWaitingListNavigation.module.scss';

export type ListType = 'patients' | 'waitingList';

interface Props {
  shownListType: ListType;
  changeListType: (newType: ListType) => void;
}

export const PatientAndWaitingListNavigation: React.FC<Props> = (props) => {
  const { shownListType, changeListType } = props;
  const i18next = useScopedTranslation('calendar');

  return (
    <div className={styles.tabs} data-test-id={'calendar-items-navigation'}>
      <div
        className={styles.tab}
        data-selected={shownListType === 'patients'}
        onClick={() => changeListType('patients')}
      >
        {i18next.t('patient_list.title')}
      </div>
      <div
        className={styles.tab}
        data-selected={shownListType === 'waitingList'}
        onClick={() => changeListType('waitingList')}
      >
        {i18next.t('waiting_list.title')}
      </div>
    </div>
  );
};
